import { render, staticRenderFns } from "./PointItem.vue?vue&type=template&id=b452c10e&scoped=true"
import script from "./PointItem.vue?vue&type=script&lang=js"
export * from "./PointItem.vue?vue&type=script&lang=js"
import style0 from "./PointItem.vue?vue&type=style&index=0&id=b452c10e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452c10e",
  null
  
)

export default component.exports